import { render, staticRenderFns } from "./TaiSan.vue?vue&type=template&id=7cbf4c5c&scoped=true"
import script from "./TaiSan.vue?vue&type=script&lang=js"
export * from "./TaiSan.vue?vue&type=script&lang=js"
import style0 from "./TaiSan.vue?vue&type=style&index=0&id=7cbf4c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbf4c5c",
  null
  
)

export default component.exports